/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { FC, ReactElement } from 'react'

import './index.css'

type HelpCategoryLinkProps = {
  ariaLabel: string
  helpCategoryId: string
  children?: ReactElement
  className?: string
}
const HelpCategoryLink: FC<HelpCategoryLinkProps> = ({ ariaLabel, helpCategoryId, children, className }): ReactElement => {
  return (
    <>
      <a className={className} href={`/help?helpCategoryId=${helpCategoryId}`} target="_blank" rel="noreferrer" aria-label={ariaLabel}>
        {children}
      </a>
    </>
  )
}

export default HelpCategoryLink
